(function () {
  'use strict';

  var selector = '.product-title-tooltip[data-product-title]';
  var tooltip = null;
  var activeTarget = null;
  var gapX = 10;
  var gapY = 14;
  var viewportPadding = 10;

  function supportsHover() {
    return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function getTooltip() {
    if (tooltip) return tooltip;

    tooltip = document.createElement('div');
    tooltip.className = 'product-title-cursor-tooltip';
    tooltip.setAttribute('role', 'tooltip');
    tooltip.setAttribute('aria-hidden', 'true');
    document.body.appendChild(tooltip);
    return tooltip;
  }

  function positionTooltip(event) {
    if (!tooltip || !activeTarget) return;

    var x = event.clientX + gapX;
    var y = event.clientY + gapY;
    var rect = tooltip.getBoundingClientRect();
    var maxX = window.innerWidth - rect.width - viewportPadding;
    var maxY = window.innerHeight - rect.height - viewportPadding;

    if (x > maxX) x = event.clientX - rect.width - gapX;
    if (y > maxY) y = event.clientY - rect.height - gapY;

    x = Math.max(viewportPadding, x);
    y = Math.max(viewportPadding, y);

    tooltip.style.left = Math.round(x) + 'px';
    tooltip.style.top = Math.round(y) + 'px';
  }

  function showTooltip(target, event) {
    var title = target.getAttribute('data-product-title');
    if (!title) return;

    activeTarget = target;
    var el = getTooltip();
    el.textContent = title;
    el.setAttribute('aria-hidden', 'false');
    el.classList.add('is-visible');
    positionTooltip(event);
  }

  function hideTooltip() {
    activeTarget = null;
    if (!tooltip) return;
    tooltip.classList.remove('is-visible');
    tooltip.setAttribute('aria-hidden', 'true');
  }

  function findTarget(node) {
    return node && node.closest ? node.closest(selector) : null;
  }

  if (!supportsHover()) return;

  document.addEventListener('mouseover', function (event) {
    var target = findTarget(event.target);
    if (!target || target === activeTarget) return;
    showTooltip(target, event);
  });

  document.addEventListener('mousemove', function (event) {
    if (activeTarget) positionTooltip(event);
  });

  document.addEventListener('mouseout', function (event) {
    if (!activeTarget) return;
    var nextTarget = findTarget(event.relatedTarget);
    if (nextTarget === activeTarget) return;
    if (!activeTarget.contains(event.relatedTarget)) hideTooltip();
  });

  document.addEventListener('scroll', hideTooltip, true);
  window.addEventListener('blur', hideTooltip);
  window.addEventListener('resize', hideTooltip);
}());
